import React from 'react';
import PropTypes from 'prop-types';

// Skeleton placeholder rows shown while the conversations PostgREST request is in flight.
// Mirrors the real Conversation row's vertical rhythm so the layout doesn't jump when data arrives.
function ConversationSkeleton({ count = 6 }) {
  return (
    <ul className="list-group rounded-0 overflow-x-hidden" aria-hidden="true">
      {Array.from({ length: count }).map((_, idx) => (
        <li
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
          className="list-group-item d-flex p-0 border-0 rounded-0 border-bottom"
          style={{ color: '#ced4da' }}
        >
          <div className="d-flex flex-column w-100" style={{ padding: '22px 32px' }}>
            <div className="d-flex flex-row align-items-center w-100 mb-2 placeholder-glow">
              <span
                className="placeholder rounded-2 flex-shrink-0"
                style={{ width: 42, height: 42, marginRight: 12 }}
              />
              <div className="flex-grow-1 d-flex align-items-center justify-content-between gap-2">
                <span className="placeholder rounded-2 col-5" />
                <span className="placeholder rounded-2 col-2" />
              </div>
            </div>
            <div className="placeholder-glow ps-5 ms-2">
              <span className="placeholder rounded-2 col-9 d-block mb-1" />
              <span className="placeholder rounded-2 col-6 d-block" />
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

ConversationSkeleton.propTypes = {
  count: PropTypes.number,
};

export default ConversationSkeleton;
